import React, {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet';
import {validationEmail} from '../../global/validate';
import axios from 'axios';
import {setLoader} from '../../store/builder/reducer';
import {setUser} from '../../store/builder/loginSlice';
import {
  setVerifyRegister,
  setVerifyRegisterTime,
} from '../../store/builder/registerSlice';
import {toast} from 'react-toastify';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import useTimer from '../../components/CustomHooks/useTimer';
import ReactCodeInput from 'react-code-input';
import {useTranslation} from '../../hooks/useTranslation';

const inputStyle = {
  fontFamily: 'monospace',
  margin: '4px',
  padding: '12px',
  width: '65px',
  height: '63px',
  borderRadius: '4px',
  border: '1px solid #ccc',
  textAlign: 'center',
  fontSize: '16px',
};

export default function ConfirmRegistration() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const verifyToken = useSelector(
    state => state.rootReducer.registerSlice.verifyToken,
  );
  const timeExpired = useSelector(
    state => state?.rootReducer?.registerSlice?.verifyTokenExpired,
  );
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const [state, setState] = useState(null);
  const [disabledBtn, setDisabledBtn] = useState(true);
  const remainingTime = useTimer(timeExpired, timeExpired);

  useEffect(() => {
    if (state?.length > 5) {
      setDisabledBtn(false);
    } else {
      setDisabledBtn(true);
    }
  }, [state]);

  const handleAgain = e => {
    dispatch(setLoader(true));
    e.preventDefault();
    let config = {
      headers: {
        AppVersion: '1.0.0',
        AppType: 'web',
        DeviceType: 'web',
      },
    };
    axios
      .post(
        `${import.meta.env.VITE_API_URL}auth/resend-email`,
        {
          user_id: userInfo.id,
        },
        config,
      )
      .then(res => {
        dispatch(setLoader(false));
        localStorage.setItem(
          'token_for_register',
          res.data?.email_verify_token,
        );
        dispatch(setVerifyRegisterTime(res.data.email_verify_token_expires_at));
        toast.success(t('confirmRegistration.codeSentSuccess'), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
      })
      .catch(err => {
        dispatch(setLoader(false));
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
      });
  };

  const handleCode = e => {
    setState(e);
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (state.length > 0) {
      dispatch(setLoader(true));
      let config = {
        headers: {
          AppVersion: '1.0.0',
          AppType: 'web',
          DeviceType: 'web',
        },
      };
      axios
        .post(
          `${import.meta.env.VITE_API_URL}auth/verify-email`,
          {
            verify_token: localStorage.getItem('token_for_register'),
            code: state,
          },
          config,
        )
        .then(res => {
          dispatch(setLoader(false));
          toast.success(res.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          setTimeout(() => {
            navigate('/subscription');
          }, 500);
        })
        .catch(err => {
          dispatch(setLoader(false));
          toast.error(err.response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
        });
    } else {
      toast.error(t('confirmRegistration.enterCorrectCode'));
    }
  };

  return (
    <div className='auth'>
      <Helmet>
        <title>{t('confirmRegistration.pageTitle')}</title>
      </Helmet>
      <div className='auth__wrapper'>
        <div className='auth__left'>
          <img src='/assets/register-bg.png' alt='bg' />
        </div>
        <div className='auth__right'>
          <div className='auth__content regist'>
            <div className='auth__back'>
              <img src='/assets/icons/back.svg' alt='icon' />
              <span style={{cursor: 'pointer'}} onClick={() => navigate(-1)}>
                {t('confirmRegistration.backToSignUp')}
              </span>
            </div>
            <h1 className='auth__title'>{t('confirmRegistration.title')}</h1>
            <form className='auth__form'>
              <ReactCodeInput
                placeholder={t('confirmRegistration.placeholder')}
                className='auth__field-codeField registration'
                onChange={handleCode}
                fields={6}
                type='number'
                inputStyle={inputStyle}
              />

                              <button
                  className={`auth__submit ${disabledBtn ? 'disabled' : ''}`}
                  disabled={disabledBtn}
                  onClick={handleSubmit}
                >
                  {t('confirmRegistration.confirm')}
                </button>
              <div>
                {remainingTime > 0 ? (
                  <span className='auth__try'>
                    {t('confirmRegistration.tryAgainIn', {time: remainingTime})}
                  </span>
                ) : (
                  <span className='auth__try again' onClick={handleAgain}>
                    {t('confirmRegistration.sendAgain')}
                  </span>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
